import * as types from '../types'

export default {
  state: {
    controls: null,

    //toggleHidden
    restaurantBoxHidden: true
  },
  mutations: {
    [types.CONTROLS]: (state, controls) => {
      state.controls = controls;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/module/dashboard.js